import type { SendbirdMessage } from '@sendbird/uikit-utils';
import { WELCOME_MESSAGE_PATTERN } from '../constants';

export const isWelcomeMessage = (message?: SendbirdMessage | null): boolean =>
    Boolean(message?.isAdminMessage() && WELCOME_MESSAGE_PATTERN.test(message.message ?? ''));
